export default "__VITE_ASSET__1Kxf5YiB__"